// iterates over filters, finds filters in state, creates filename for flat json, retrieves it from data directory
// structure: base _ filtervalue _ repeat
import * as d3 from 'd3'
import store from '../store'
export default async function retrieveDaqsJson (state, pageObject, dv) {
  let filename = '/data/' +
    pageObject.key.toLowerCase() +
    '/dashboard' +
    pageObject.key.toLowerCase()
  for (const filterKey in pageObject.filters()) {
    for (const attribute in state) {
      if (attribute.includes(filterKey) && attribute.includes('_filter')) {
        filename += '_' + filterKey + state[attribute].replace(/\s+/g, '')
      }
    }
  }
  let data = d3
    .json(filename + '.json')
    .then(function (root) {
      store.commit('SET_REQUEST_FAILED', false)
      Object.keys(root).forEach(key => {
        let datum = root[key]
        if (typeof datum === 'object') {
          datum.forEach(entry => {
            Object.keys(entry).forEach(key2 => {
              if (!key2.toLowerCase().includes('label') && !key2.toLowerCase().includes('suppressed') && key2 !== 'id') {
                entry[key2] = Math.round(entry[key2])
              }
            })
          })
        }
      })
      return root
    })
    .catch(function (e) {
      store.commit('SET_REQUEST_FAILED', true)
      throw String(e)
    })

  return data
}
